import React, { Component } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";
import { Form, Button } from "semantic-ui-react";
import "./button_informed.css";
import "./button.css";
import ControlTitle from "../ControlTitle";
var decode = require("unescape");

class ToggleButton extends Component {
  shouldComponentUpdate(nextProps) {
    const different =
      this.props.element_value !== nextProps.element_value ||
      this.props.error !== nextProps.error ||
      this.props.validate !== nextProps.validate;
    return different;
  }

  handleChange(e) {
    if (this.props.element_value === decode(e.target.textContent)) {
      this.props.onChange(this.props.repeatingForm, this.props.element_id, "");
      ReactDOM.findDOMNode(this.refs.UnToggle).blur();
    } else {
      this.props.onChange(
        this.props.repeatingForm,
        this.props.element_id,
        decode(e.target.textContent)
      );
    }
  }

  getToggleButtons() {
    const { validate, error, ...formControl } = this.props;

    var toggleButtons = [];

    var params = formControl.element_params.V.split("\r\n");

    params.forEach((element_param, index) => {
      let ep = decode(element_param);

      if (this.props.element_value === ep) {
        toggleButtons.push(
          <Button
            className="ui button"
            ref="UnToggle"
            role="button"
            onClick={this.handleChange.bind(this)}
            active
            key={index}
          >
            {ep}
          </Button>
        );
      } else {
        toggleButtons.push(
          <Button
            className="ui button"
            role="button"
            onClick={this.handleChange.bind(this)}
            key={index}
          >
            {ep}
          </Button>
        );
      }
    });

    if (validate && error) {
      return (
        <span>
          <div className="errorBox">{toggleButtons}</div>
        </span>
      );
    }
    return <span>{toggleButtons}</span>;
  }

  render() {
    const { element_prompt, element_value, ...formControl } = this.props;

    return (
      <div className="formControlItem">
        <Form.Field>
          <ControlTitle
            text={element_prompt}
            optional={formControl.element_optional === "1" ? true : false}
          ></ControlTitle>
          {this.getToggleButtons()}
        </Form.Field>
      </div>
    );
  }
}

ToggleButton.propTypes = {
  element_prompt: PropTypes.string.isRequired,
  element_value: PropTypes.string,
  element_id: PropTypes.number.isRequired,
  error: PropTypes.bool.isRequired,
  validate: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired
};

export default ToggleButton;



// WEBPACK FOOTER //
// ./src/components/ToggleButton/index.js